import { useReadContract } from "wagmi";

const useIsWhitelistActive = (address, abi, provider) => {
  return useReadContract({
    address: address,
    abi: abi,
    functionName: "whitelistEnabled",
    args: [],
    provider: provider
  });
};

export default useIsWhitelistActive;
